import { render, staticRenderFns } from "./NeuBau.vue?vue&type=template&id=b9db88dc&scoped=true&"
import script from "./NeuBau.vue?vue&type=script&lang=js&"
export * from "./NeuBau.vue?vue&type=script&lang=js&"
import style0 from "./NeuBau.vue?vue&type=style&index=0&id=b9db88dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db88dc",
  null
  
)

export default component.exports